export const FILE_BROWSER_CURRENT_DIR_QUERY_PARAM = 'currentDirId';
